import { BrokerExtensions } from "@primaria/plugins-core";
import { SearchItemsHandler } from "./handler";
import { SearchActivityHistoryItems } from "./request";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import "./activity-history-search-results/activity-history-search-results";
import "./activity-history-search-bar/activity-history-search-bar";
import "../filter/UI/active-filters-badges/active-filters-badges";

let request: BrokerDisposableHandler;

export const bootstrapSearchItems = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SearchActivityHistoryItems, SearchItemsHandler);
};

export const teardownSearchItems = () => {
  request?.dispose();
};
